<template lang="pug">
  router-link.btn(v-if="to" :to="to" :class="computedClasses")
    slot
    | {{ this.$slots.default ? null : tr.menu.btn }}

  a.btn(v-else :href="href" :class="computedClasses" @click="$emit('click')")
    slot
    | {{ this.$slots.default ? null : tr.menu.btn }}
</template>

<script>
export default {
  data () {
    return {
      section: 'header'
    }
  },
  props: {
    to: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    white: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    xSmall: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedClasses () {
      const classes = []

      const boolModifiers = [
        { value: !this.white, stringName: 'btn_color' },
        { value: this.xLarge, stringName: 'btn_size_xl' },
        { value: this.large, stringName: 'btn_size_l' },
        { value: this.medium, stringName: 'btn_size_m' },
        { value: this.small, stringName: 'btn_size_s' },
        { value: this.xSmall, stringName: 'btn_size_xs' }
      ]

      boolModifiers.forEach(item => {
        if (typeof item.value === 'boolean' && item.value === true) {
          classes.push(item.stringName)
        }
      })

      return classes.join(' ')
    }
  }
}
</script>
<style lang="scss">
  .btn {
    color: #000;
    text-decoration: none;
    border-radius: 4px;
    cursor: pointer;

    &_color {
      background: $main_color;
      color: #fff;
    }

    &_size_xl {
      padding: 25px 60px;
      @media (max-width: 480px) {
        padding: 25px 20px;
      }
    }

    &_size_l {
      padding: 20px 40px;
    }

    &_size_m {
      padding: 15px 20px;
    }

    &_size_s {
      padding: 12px 20px;
      font-size: 16px;
    }

    &_size_xs {
      padding: 6px 7px 4px;
    }
  }
</style>
